export enum TrapViewIntegrationError {
  USER_NOT_FOUND = 'USER_NOT_FOUND',
  PROPERTY_ALREADY_INTEGRATED = 'PROPERTY_ALREADY_INTEGRATED',
  GENERIC_ERROR = 'GENERIC_ERROR'
}

export enum TrapviewInstallationError {
  NOT_FOUND_PEST_CODE = 'Could not found template'
}
